/*
 * @Author: 迟长志 943512491@qq.com
 * @Date: 2023-04-17 13:41:26
 * @LastEditors: 迟长志 943512491@qq.com
 * @LastEditTime: 2023-04-18 14:58:59
 * @FilePath: /luckysheet-react/src/component/Luckysheet.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import {
	Button,
	Checkbox,
	Col,
	DatePicker,
	Form,
	Input,
	InputNumber,
	message,
	Row,
	TimePicker,
} from "antd";
const options = {
	container: "luckysheet",
	showsheetbar: false,
	showinfobar: false,
	// plugins: ['chart'],
	// title: 'Luckysheet Demo', // 设定表格名称
	lang: "zh", // 设定表格语言
	showstatisticBar: true, // 默认就是true，可以不设置
	showstatisticBarConfig: {
		view: false,
	},
};
class Luckysheet extends React.Component {
	constructor() {
		this.state = {};
	}
	componentDidMount() {
		const luckysheet = window.luckysheet;
		console.log(luckysheet, "luckysheet");
		luckysheet.create(options);
		this.setState({ luckysheet });
		console.log("=>>>>1");
		// setTimeout(() => {
		//     console.log(luckysheet, 'luckysheet')
		//     luckysheet.create({
		//         container: "luckysheet",
		//         plugins: ['chart']
		//     });
		// }, 500);
	}
	render() {
		const luckyCss = {
			margin: "0px",
			padding: "0px",
			position: "absolute",
			width: "100%",
			height: "100%",
			left: "0px",
			top: "0px",
		};
		return (
			<>
				{/* <Button
					// onClick={() => {
					// 	this.state.luckysheet.getAllSheets();
					// }}
				>
					wwwww
				</Button> */}
				<div id="luckysheet" style={luckyCss}></div>
			</>
		);
	}
}

export default Luckysheet;
